import styled from "styled-components";

export const NavigationButton = styled.button<{
  $disabled?: boolean;
}>`
  display: inline-flex;
  box-sizing: border-box;
  line-height: 1.35;
  align-items: center;
  background-color: transparent;
  color: var(--ons-color-text-link);
  border: 2px solid transparent;
  border-radius: 3px;
  padding: 10px;
  margin-bottom: 4px;
  font-weight: 400 !important;

  svg {
    fill: var(--ons-color-text-link);
    height: 18px;
    vertical-align: middle;
    width: 18px;
    margin-bottom: 4px;
  }

  font-size: 16px;
  ${(props) => props.$disabled && "opacity: 50%;"}
  &:hover {
    border: ${(props) =>
      props.$disabled
        ? "2px solid transparent"
        : "2px solid var(--ons-color-text-link)"};
  }

  ${(props) =>
    !props.$disabled &&
    `
    &:focus {
      border: 2px solid var(--ons-color-black);
      color: var(--ons-color-black);
      fill: var(--ons-color-black);
      background-color: var(--ons-color-sun-yellow);
    }
  
    &:focus-visible {
      outline: none;
    }
  `}

  /* Media query to change display based on screen width */
  @media (max-width: 739px) {
    display: block; /* Change display for small screens */
    margin-left: 0 !important;
  }
`;
